import React, {memo} from "react";

export const IconQuestion = memo(({color}) => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9.5 17C9.224 17 9 16.776 9 16.5V13.5C9 13.224 9.224 13 9.5 13C12.533 13 15 10.533 15 7.5C15 4.467 12.533 2 9.5 2C6.467 2 4 4.467 4 7.5C4 7.776 3.776 8 3.5 8C3.224 8 3 7.776 3 7.5C3 3.916 5.916 1 9.5 1C13.084 1 16 3.916 16 7.5C16 10.916 13.351 13.725 10 13.981V16.5C10 16.776 9.776 17 9.5 17Z"
        fill={color || "#000"}
      />
      <path
        d="M9.5 20C9.224 20 9 19.776 9 19.5V18.5C9 18.224 9.224 18 9.5 18C9.776 18 10 18.224 10 18.5V19.5C10 19.776 9.776 20 9.5 20Z"
        fill={color || "#000"}
      />
    </svg>
  );
});
